/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { INosAnchorProps } from './nos-anchor.props.autogenerated';

/**
 *
 * NosAnchor component
 * @extends {React.PureComponent<INosAnchorProps<INosAnchorData>>}
 */

export interface INosAnchorViewProps extends INosAnchorProps<{}> {}

class NosAnchor extends React.PureComponent<INosAnchorProps<{}>> {
    public render(): JSX.Element | null {
        const idName = this.props.config.idName;
        const regex = /^[A-Za-z]+[\w\-\:\.]*$/;

        if (regex.test(idName)) {
            return this.props.renderView(this.props);
        }

        return null;
    }
}

export default NosAnchor;
